var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOneRoom = function SvgOneRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#one-room_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M34.139 20.984V48.73m0-27.746h20.808"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.156,
    d: "M54.95 20.984V48.73M1 20.984V48.73"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1 20.984V49.5h53.948V20.599L38.764 1.717H17.57z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M34.139 21.37 17.954 2.101"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "one-room_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.478,
    height: 10.019,
    x: 11.789,
    y: 22.912,
    rx: 0.771
  })), /*#__PURE__*/React.createElement("rect", {
    width: 8.478,
    height: 10.019,
    x: 11.789,
    y: 22.912,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#one-room_svg__b)",
    rx: 0.771
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "one-room_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v48H0z"
  })))));
};
export default SvgOneRoom;